import { render, staticRenderFns } from "./pkqUserStatisticsDt.vue?vue&type=template&id=e19bde2e&scoped=true"
import script from "./pkqUserStatisticsDt.vue?vue&type=script&lang=js"
export * from "./pkqUserStatisticsDt.vue?vue&type=script&lang=js"
import style0 from "./pkqUserStatisticsDt.vue?vue&type=style&index=0&id=e19bde2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19bde2e",
  null
  
)

export default component.exports